import React from "react";

import IconBase, { IconBaseProps } from "./IconBase";

/**
 * Urine — 20×20 lab group icon (Figma 837:69).
 * Specimen-cup style, single 15×15 layer centered (inset 12.5%).
 */
const IconUrine: React.FC<IconBaseProps> = ({
  size = 24,
  color = "currentColor",
  className = "",
  ...props
}) => {
  const iconSize =
    typeof size === "number" ? size : parseInt(size as string, 10) || 24;
  return (
    <IconBase
      size={iconSize}
      color={color}
      className={className}
      viewBox="0 0 20 20"
      {...props}
    >
      <g transform="translate(2.5 2.5)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.366117 0.366117C0.139913 0.592321 0 0.904821 0 1.25V3.33333H0.890708C0.890729 3.35171 0.89135 3.37017 0.892591 3.38875L1.61481 14.2221C1.644 14.6598 2.00758 15 2.44629 15H12.137C12.5757 15 12.9393 14.6598 12.9685 14.2221L13.6907 3.38875C13.692 3.37017 13.6926 3.35171 13.6926 3.33333H15V1.25C15 0.879792 14.839 0.547171 14.5833 0.318287C14.5782 0.313758 14.5732 0.309267 14.568 0.304817C14.4824 0.230667 14.3867 0.167954 14.2831 0.119046C14.2677 0.111804 14.2523 0.104863 14.2365 0.0982292C14.087 0.0349792 13.9226 0 13.75 0H1.25C1.05932 0 0.878608 0.0426958 0.716913 0.119046C0.713958 0.120442 0.711012 0.121846 0.708075 0.123262C0.601696 0.174521 0.503692 0.240396 0.416667 0.318287C0.399375 0.333762 0.382521 0.349713 0.366117 0.366117ZM12.8593 3.33333H1.72408L1.83521 5H6.25C6.71025 5 7.08333 5.37308 7.08333 5.83333V6.66667H12.637L12.8593 3.33333ZM2.13092 5.83333L2.455 11.6667H6.25V5.83333H2.13092ZM2.08333 2.38096H1.25V0.952379H2.08333V2.38096ZM3.75 0.952379H2.91667V2.38096H3.75V0.952379ZM5.41667 2.38096H4.58333V0.952379H5.41667V2.38096ZM7.08333 0.952379H6.25V2.38096H7.08333V0.952379ZM8.75 2.38096H7.91667V0.952379H8.75V2.38096ZM10.4167 0.952379H9.58333V2.38096H10.4167V0.952379ZM12.0833 2.38096H11.25V0.952379H12.0833V2.38096ZM13.75 0.952379H12.9167V2.38096H13.75V0.952379Z"
        />
      </g>
    </IconBase>
  );
};

export default IconUrine;
